module.exports = __webpack_public_path__ + "img/HU.9a3e63dd.svg";